import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";

import { Card, Col, Row, Form, Button } from "@themesberg/react-bootstrap";

import api from "../../../api";
import DatePickerComponent from "../../../components/DatePickerComponent";
import AdminLayout from "../../../layout/admin";
import { Header } from "../../../components/admin";
import moment from "moment";
import { UserContext } from "../../../utils/ProtectedRoute";
import Chart from "react-apexcharts";
import { formatToRupiah } from "../../../helpers/helper";

const OverviewCashflowPage = () => {
  const { userData } = useContext(UserContext);

  const [dataFakultas, setDataFakultas] = useState([]);
  const [dataProdi, setDataProdi] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [toggle, setToggle] = useState(false);

  const [dataForm, setDataForm] = useState({
    startDate: new Date().setDate(1),
    endDate: new Date(),
    idFakultas: "",
    idProdi: "",
  });

  useEffect(() => {
    const source = axios.CancelToken.source();
    const getAllResource = async () => {
      try {
        const fakultasResponse = await axios.get(`${api}/master/fakultas`, {
          cancelToken: source.token,
        });
        const fakultasFormated = fakultasResponse.data.data.map((fakultas) => ({
          value: fakultas.id,
          label: fakultas.nama,
        }));

        setDataFakultas(fakultasFormated);
      } catch (error) {}
    };

    getAllResource();
    return () => {
      source.cancel("Komponen dibongkar, membatalkan permintaan.");
    };
  }, []);

  useEffect(() => {
    // set fakultas by user data
    const fakultasUser = dataFakultas.find(
      (e) => e.value === userData?.id_fakultas
    );
    setDataForm({
      ...dataForm,
      idFakultas: fakultasUser?.value,
      idProdi: null,
    });
  }, [userData, dataFakultas]);

  useEffect(() => {
    // Jika newUser.id_fakultas tidak kosong, ambil data prodi
    if (dataForm.idFakultas) {
      axios
        .get(`${api}/master/prodi/get_by_fakultas_id/${dataForm.idFakultas}`)
        .then((prodiResponse) => {
          const prodiFormated = prodiResponse.data.data.map((prodi) => ({
            value: prodi.id,
            label: prodi.nama,
          }));

          setDataProdi(prodiFormated);
        });
    } else {
      // Jika newUser.id_fakultas kosong, set dataProdi menjadi array kosong
      setDataProdi([]);
    }
  }, [dataForm.idFakultas]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setToggle(!toggle);
    setIsSubmitted(true);
  };

  return (
    <AdminLayout>
      <div className="d-xl-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <Header title="Overview Cashflow Fakultas" />
        </div>
      </div>
      <Card border="light" className="shadow-sm mb-4">
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={12} className="mb-3">
                <Row>
                  <Col md={6}>
                    <Form.Group id="startDate">
                      <Form.Label>Start Date</Form.Label>
                      <DatePickerComponent
                        className="form-control"
                        dateFormat="dd/MM/yyyy"
                        selectsStart={true}
                        value={dataForm.startDate}
                        maxDate={dataForm.endDate}
                        onChange={(update) => {
                          setDataForm({ ...dataForm, startDate: update });
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group id="endDate">
                      <Form.Label>End Date</Form.Label>
                      <DatePickerComponent
                        className="form-control"
                        dateFormat="dd/MM/yyyy"
                        selectsEnd={true}
                        minDate={dataForm.startDate}
                        value={dataForm.endDate}
                        onChange={(update) => {
                          setDataForm({ ...dataForm, endDate: update });
                        }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Col>
              <Col md={12} className="mb-3">
                <Form.Group id="fakultas">
                  <Form.Label>Fakultas</Form.Label>
                  <Select
                    options={dataFakultas}
                    placeholder="Pilih fakultas"
                    value={dataFakultas.find(
                      (e) => e.value === dataForm.idFakultas
                    )}
                    onChange={(e) =>
                      setDataForm({
                        ...dataForm,
                        idFakultas: e?.value,
                        namaFakultas: e?.label,
                        idProdi: null,
                        namaProdi: null,
                      })
                    }
                    isClearable={true}
                    isDisabled
                  />
                </Form.Group>
              </Col>
              <Col md={12} className="mb-3">
                <Form.Group id="prodi">
                  <Form.Label>Prodi</Form.Label>
                  <Select
                    options={dataProdi}
                    placeholder="Pilih prodi"
                    isDisabled={!dataForm.idFakultas}
                    value={
                      dataProdi.find((e) => e.value === dataForm.idProdi) ||
                      null
                    }
                    isClearable={true}
                    onChange={(e) =>
                      setDataForm({
                        ...dataForm,
                        idProdi: e?.value,
                        namaProdi: e?.label,
                      })
                    }
                  />
                </Form.Group>
              </Col>
              {isSubmitted ? (
                <Col md="12">
                  <Row>
                    <PieChartComponent
                      data={dataForm}
                      isDebet={true}
                      toggle={toggle}
                    />
                    <PieChartComponent
                      data={dataForm}
                      isDebet={false}
                      toggle={toggle}
                    />
                  </Row>
                </Col>
              ) : null}
              <Col md="12">
                <Button type="submit">Submit</Button>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>
    </AdminLayout>
  );
};

// component untuk chart point survey
const PieChartComponent = (props) => {
  const token = localStorage.getItem("token");
  const { data, isDebet, toggle } = props;
  const [responseState, setResponseState] = useState({
    loading: false,
    data: [],
    exception: null,
  });

  const [options, setOptions] = useState({
    series: [],
    chartOptions: {
      labels: [],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 300,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
    },
  });

  useEffect(() => {
    const source = axios.CancelToken.source();
    const body = Object.assign(
      {
        ...data,
      },
      {
        startDate: moment(data.startDate).format("YYYY-MM-DD"),
        endDate: moment(data.endDate).format("YYYY-MM-DD"),
        isDebet: isDebet,
      }
    );
    const getData = async () => {
      try {
        setResponseState({ loading: true, data: null, exception: null });
        const response = await axios.post(
          `${api}cashflow/report/piechart`,
          body,
          {
            headers: {
              Authorization: token,
            },
            cancelToken: source.token,
          }
        );
        setResponseState({
          loading: false,
          data: response.data,
          exception: null,
        });
      } catch (error) {
        setResponseState({
          loading: false,
          data: null,
          exception: "Oopps!, something went wrong!",
        });
      }
    };

    getData();
    return () => {
      source.cancel("Komponen dibongkar, membatalkan permintaan.");
    };
  }, [data, isDebet, toggle]);

  // option chart line
  useEffect(() => {
    setOptions({
      series: (responseState.data?.data || [])?.map((e) =>
        parseFloat(isDebet ? e.pemasukan : e.pengeluaran)
      ),
      chartOptions: {
        labels: (responseState.data?.data || [])?.map((e) => e.name),
        legend: {
          position: "bottom",
          // horizontalAlign: 'left',
          // formatter: function (seriesName, opts) {
          //   return [seriesName, " - ", opts.w.globals.series[opts.seriesIndex]];
          // },
          // tooltipHoverFormatter: function (seriesName, opts) {
          //   return (
          //     seriesName +
          //     " - <strong>" +
          //     formatToRupiah(opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex]) +
          //     "</strong>"
          //   );
          // },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return formatToRupiah(val); // Format the number to two decimal places
            },
          },
        },
        responsive: [
          {
            breakpoint: 1137,
            options: {
              chart: {
                width: 300,
                height: 450,
              },
            },
          },
          {
            breakpoint: 980,
            options: {
              chart: {
                width: 450,
                height: 800,
              },
            },
          },
          {
            breakpoint: 500,
            options: {
              chart: {
                width: 350,
                height: 800,
              },
            },
          },
        ],
      },
    });
  }, [responseState]);

  return (
    <Col xs="12" lg="6">
      <Col
        style={{
          textAlign: "center",
        }}
      >
        <h5>{isDebet ? "PEMASUKAN" : "PENGELUARAN"}</h5>
      </Col>
      <Col
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {responseState.loading ? (
          <p>Loading...</p>
        ) : (responseState.data?.data || []).length > 0 ? (
          <Chart
            options={options.chartOptions}
            series={options.series}
            type="pie"
            width="400"
            height="500"
          />
        ) : (
          <p>Belum ada data!</p>
        )}
      </Col>
    </Col>
  );
};

export default OverviewCashflowPage;
